import { render, staticRenderFns } from "./SalesProduct.vue?vue&type=template&id=49bd4c8e&scoped=true&"
import script from "./SalesProduct.vue?vue&type=script&lang=js&"
export * from "./SalesProduct.vue?vue&type=script&lang=js&"
import style0 from "./SalesProduct.vue?vue&type=style&index=0&id=49bd4c8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49bd4c8e",
  null
  
)

export default component.exports